import { Box, CircularProgress, IconButton, Typography } from "@mui/material";

const LoaderSpinner = ({ text, height }) => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      sx={{ height: height ? height : "" }}
      justifyContent={"center"}
    >
      <IconButton color="inherit">
        <CircularProgress size={19} color="inherit" />
      </IconButton>
      {text && (
        <Typography ml={1} color={"inherit"}>
          Loading
        </Typography>
      )}
    </Box>
  );
};

export default LoaderSpinner;
